<template>
  <div
    class="w-full"
    :class="isFullScreen ? 'fixed z-101 h-full flex items-center justify-center' : ''"
    data-testid="content-edit-media-preview"
  >
    <ModalBlank
      v-if="isFullScreen && mediaType === 'image'"
      wrapper-class="bg-white dark:bg-slate-800 rounded-lg shadow-lg overflow-auto max-w-2xl w-full max-h-full"
      @close-modal="exitFullScreen"
    >
      <div class="w-full">
        <img :src="url" alt="media preview" class="object-cover w-full min-h-40" />
        <span class="absolute top-4 right-4">
          <AppButton variant="danger" icon="pi pi-times" @click="exitFullScreen()" />
        </span>
      </div>
    </ModalBlank>

    <div v-else class="w-full">
      <img
        v-if="mediaType === 'image'"
        :src="url"
        alt="media preview"
        class="object-cover w-full min-h-40"
      />
      <ShortVideoPlayer
        v-else-if="mediaType === 'video'"
        :url="url"
        :full-details="true"
      />

      <div class="flex items-center justify-center gap-4 mt-4">
        <AppButton
          variant="secondary"
          icon="pi pi-times"
          :class="mediaType === 'image' ? 'reject-image' : 'reject-video'"
          :data-testid="
            mediaType === 'image' ? 'content-edit-image-preview-cancel-button' : undefined
          "
          @click="emit('cancel')"
        />
        <AppButton
          v-if="mediaType === 'image'"
          variant="secondary"
          icon="pi pi-expand"
          data-testid="content-edit-image-preview-fullscreen-button"
          @click="toggleFullScreen(true)"
        />
        <AppButton
          :icon="mediaType === 'image' ? 'pi pi-check' : 'pi pi-check'"
          :class="mediaType === 'image' ? 'accept-image' : 'accept-video'"
          :data-testid="
            mediaType === 'image' ? 'content-edit-image-preview-accept-button' : undefined
          "
          @click="emit('accept', url)"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount } from "vue";
import ModalBlank from "@/partials/ModalBlank.vue";
import ShortVideoPlayer from "@/components/shared/ShortVideoPlayer.vue";

const props = defineProps<{
  url: string;
  mediaType: "image" | "video";
  fullScreen?: boolean;
}>();

const emit = defineEmits<{
  accept: [string];
  cancel: [];
  exitFullScreen: [];
}>();

const [isFullScreen, toggleFullScreen] = useToggle(props.fullScreen);

// Revoke blob URL on unmount to prevent memory leaks
onBeforeUnmount(() => {
  if (props.url && props.url.startsWith("blob:")) {
    URL.revokeObjectURL(props.url);
  }
});

function exitFullScreen() {
  toggleFullScreen(false);
  emit("exitFullScreen");
}
</script>
